import { defineComponent as _defineComponent } from 'vue'
import BCXDatepickerField from '@/components/molecules/forms/datepicker/BCXDatepickerField.vue';
import useAvailabilityState from '@/state/availabilityState';

import { ref, watch } from 'vue';
import X from '@/components/svg-components/X.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewAvailabilityDateSelect',
  emits: ['dates'],
  setup(__props, { emit }) {

const { availability } = useAvailabilityState();



const today = ref(new Date());

const from = ref(availability.value?.availableFrom ?? new Date());
const to = ref(availability.value?.availableTo ?? '');

const removeTo = () => {
  to.value = '';
};

watch([from, to], () => {
  emit('dates', { from: from.value, to: to.value });
});


return { __sfc: true,availability, emit, today, from, to, removeTo, BCXDatepickerField, X }
}

})